<script setup lang="ts">
const { required, acceptAll, acceptEssential } = useCookieConsent();
const { t } = useI18n();
const config = ref(false);
const cookieOptions = ref([
  {
    label: t('cookies.essential'),
    value: 'essential',
    description: t('cookies.essential.description'),
    disabled: true,
    selected: true,
  },
  {
    label: t('cookies.optional'),
    value: 'thirdParty',
    description: t('cookies.optional.description'),
    disabled: false,
    selected: true,
  },
]);
</script>
<template>
  <UModal :open="required" :dismissible="false" :close="false">
    <template #title>
      <TextHeading tag="h1" variant="modal">{{ $t('cookies.heading') }}</TextHeading>
    </template>
    <template #body>
      <p>
        <i18n-t keypath="cookies.explained" tag="p">
          <template #brand><TextBrand /></template>
          <template #privacyLink>
            <AppLink to="https://opebo.de/privacy-policy" :label="$t('cookies.seeMore')">{{ $t('cookies.privacy') }}</AppLink>
          </template>
        </i18n-t>
      </p>
      <template v-if="config">
        <UCard class="my-4">
          <template v-for="option in cookieOptions" :key="option.value">
            <div class="flex sm:justify-between my-4">
              <p>
                {{ option.label }}<br />
                <span class="text-sm text-gray-500 dark:text-gray-400">{{ option.description }}</span>
              </p>
              <USwitch v-model="option.selected" :disabled="option.disabled" />
            </div>
          </template>
        </UCard>
      </template>
    </template>

    <template #footer>
      <div v-if="config" class="flex justify-center gap-x-4 w-full">
        <UButton :label="$t('cookies.acceptAll')" variant="solid" @click="acceptAll" />
        <UButton :label="$t('cookies.saveConfig')" @click="acceptEssential" />
      </div>
      <div v-else class="flex justify-center gap-x-4 w-full">
        <UButton :label="$t('cookies.acceptAll')" variant="solid" @click="acceptAll" />
        <UButton :label="$t('cookies.edit')" @click="config = true" />
      </div>
    </template>
  </UModal>
</template>
